export default "__VITE_ASSET__yWuj5Y6X__";